import React, { useState } from 'react';
import { Box, Typography, Button, Modal, useMediaQuery, useTheme } from '@mui/material';
import Navbar from '../components/Navbar/Navbar';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import FloatingSummaryButton from '../services/FloatingSummaryButton';
// Importa tus imágenes
import FacebookIcon from '../img/facebook.svg';
import InstagramIcon from '../img/instagram.svg';
import Youtube from '../img/youtube.svg';
import GalleryImage1 from '../img/galery/1.jpg';
import GalleryImage2 from '../img/galery/2.jpg';
import GalleryImage3 from '../img/galery/3.jpg';

const Home = () => {
    const [openModal, setOpenModal] = useState(false);
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('md'));
    const isSmallMobile = useMediaQuery(theme.breakpoints.down('sm'));

    const handleOpenModal = () => setOpenModal(true);
    const handleCloseModal = () => setOpenModal(false);

    const socialMedia = [
        { icon: FacebookIcon, alt: 'Facebook', link: '#' },
        { icon: InstagramIcon, alt: 'Instagram', link: '#' },
        { icon: Youtube, alt: 'Youtube', link: '#' }
    ];

    const galleryImages = [
        GalleryImage1,
        GalleryImage2,
        GalleryImage3
    ];

    return (

        <Box sx={{ backgroundColor: '#313131', minHeight: '100vh' }}>
            <Navbar />
            {/* Botón flotante */}
            <FloatingSummaryButton precotizacionData />
            <Box sx={{
                display: 'flex',
                flexDirection: isMobile ? 'column' : 'row',
                minHeight: 'calc(100vh - 64px)',
                position: 'relative',
                overflow: isMobile ? 'auto' : 'hidden'
            }}>
                {/* Sección izquierda (40% en desktop, 100% en móvil) */}
                <Box sx={{
                    width: isMobile ? '100%' : '40%',
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    p: isMobile ? 4 : 6,
                    position: 'relative',
                    minHeight: isMobile ? 'auto' : 'auto',
                    order: 1 // Siempre primero
                }}>
                    {/* Contenedor de texto */}
                    <Box sx={{
                        ml: isMobile ? 0 : 12,
                        position: 'relative',
                        zIndex: 2,
                        textAlign: isMobile ? 'center' : 'left'
                    }}>
                        {/* Línea neon vertical - Solo en desktop */}
                        {!isMobile && (
                            <Box sx={{
                                position: 'absolute',
                                left: -40,
                                top: 0,
                                height: '240px',
                                width: '15px',
                                backgroundColor: '#EBC848',
                                boxShadow: '0 0 10px #EBC848, 0 0 20px #EBC848',
                                zIndex: 1
                            }} />
                        )}

                        {/* Título */}
                        <Typography variant="h1" sx={{
                            fontFamily: 'Montserrat, sans-serif',
                            fontWeight: 700,
                            color: 'white',
                            fontSize: isSmallMobile ? '2rem' : isMobile ? '2.5rem' : '3.5rem',
                            lineHeight: 1.2,
                            mb: 4,
                            textTransform: 'uppercase',
                            position: 'relative',
                            pl: isMobile ? 0 : 4
                        }}>
                            SOLUCIONES ENERGÉTICAS, SOSTENIBLES Y EFICIENTES
                        </Typography>

                        {/* Subtítulo */}
                        <Typography variant="h5" sx={{
                            fontFamily: 'Montserrat, sans-serif',
                            fontWeight: 400,
                            color: 'white',
                            fontSize: isMobile ? '1rem' : '1.2rem',
                            mb: 6,
                            maxWidth: isMobile ? '100%' : '80%',
                            mx: isMobile ? 'auto' : 0
                        }}>
                            Especialistas en el ahorro energético de tu hogar o empresa, mediante el uso de la energía solar.
                        </Typography>

                        {/* Botón */}
                        <Box sx={{
                            display: 'flex',
                            justifyContent: isMobile ? 'center' : 'flex-start',
                            mb: isMobile ? 2 : 0
                        }}>
                            <Button
                                variant="contained"
                                onClick={handleOpenModal}
                                sx={{
                                    backgroundColor: 'transparent',
                                    border: '2px solid #EBC848',
                                    boxShadow: '0 0 10px #EBC848',
                                    color: 'white',
                                    fontFamily: 'Montserrat, sans-serif',
                                    fontWeight: 600,
                                    fontSize: isMobile ? '0.9rem' : '1.1rem',
                                    py: isMobile ? 1.5 : 2,
                                    px: isMobile ? 3 : 4,
                                    borderRadius: 0,
                                    '&:hover': {
                                        backgroundColor: 'rgba(235, 200, 72, 0.1)',
                                        boxShadow: '0 0 15px #EBC848'
                                    }
                                }}
                            >
                                Más Información
                                <KeyboardArrowRightIcon sx={{
                                    color: '#EBC848',
                                    ml: 1,
                                    fontSize: isMobile ? '1.2rem' : '1.5rem'
                                }} />
                            </Button>
                        </Box>
                    </Box>

                    {/* Redes sociales - Versión móvil (vertical) */}
                    {isMobile && (
                        <Box sx={{
                            position: 'fixed',
                            top: '50%',
                            left: 10,
                            transform: 'translateY(-50%)',
                            display: 'flex',
                            flexDirection: 'column',
                            gap: 2,
                            zIndex: 999
                        }}>
                            {socialMedia.map((social, index) => (
                                <Box
                                    component="img"
                                    key={index}
                                    src={social.icon}
                                    alt={social.alt}
                                    sx={{
                                        width: 35,
                                        height: 35,
                                        cursor: 'pointer',
                                        transition: 'transform 0.3s',
                                        '&:hover': {
                                            transform: 'scale(1.1)'
                                        }
                                    }}
                                />
                            ))}
                        </Box>
                    )}
                </Box>

                {/* Sección derecha (60% en desktop, 100% en móvil) - Galería */}
                <Box
                    sx={{
                        width: isMobile ? '100%' : '60%',
                        display: 'flex',
                        flexDirection: isMobile,
                        gap: 2,
                        p: 2,
                        overflow: 'hidden',
                        order: isMobile ? 3 : 2 // en móvil se muestra después del botón
                    }}
                >
                    {galleryImages.map((image, index) => (
                        <Box
                            key={index}
                            component="img"
                            src={image}
                            alt={`Gallery ${index + 1}`}
                            sx={{
                                width: isMobile ? '100%' : '33.33%',
                                height: isMobile ? '300px' : '100%',
                                objectFit: 'cover',
                                transition: 'transform 0.5s',
                                mb: isMobile ? 2 : 0,
                                '&:hover': {
                                    transform: isMobile ? 'none' : 'scale(1.03)'
                                }
                            }}
                        />
                    ))}
                </Box>

                {/* Redes sociales - Versión desktop */}
                {!isMobile && (
                    <Box sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        gap: 3,
                        position: 'absolute',
                        left: 20,
                        top: '60%',
                        transform: 'translateY(-50%)',
                        zIndex: 2
                    }}>
                        {socialMedia.map((social, index) => (
                            <Box
                                component="img"
                                key={index}
                                src={social.icon}
                                alt={social.alt}
                                sx={{
                                    width: 40,
                                    height: 40,
                                    cursor: 'pointer',
                                    transition: 'transform 0.3s',
                                    '&:hover': {
                                        transform: 'scale(1.1)'
                                    }
                                }}
                            />
                        ))}
                    </Box>
                )}
            </Box>

            {/* Modal */}
            <Modal
                open={openModal}
                onClose={handleCloseModal}
                aria-labelledby="more-info-modal"
                aria-describedby="more-information-about-services"
            >
                <Box sx={{
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    width: isMobile ? '90%' : 600,
                    bgcolor: '#313131',
                    border: '2px solid #EBC848',
                    boxShadow: '0 0 20px #EBC848',
                    p: 3,
                    outline: 'none',
                    maxHeight: '90vh',
                    overflowY: 'auto'
                }}>
                    <Typography variant="h4" sx={{
                        color: '#EBC848',
                        fontFamily: 'Montserrat, sans-serif',
                        fontWeight: 700,
                        mb: 3,
                        fontSize: isMobile ? '1.5rem' : '2rem'
                    }}>
                        Más Información
                    </Typography>
                    <Typography sx={{
                        color: 'white',
                        fontFamily: 'Montserrat, sans-serif',
                        mb: 3,
                        fontSize: isMobile ? '0.9rem' : '1rem'
                    }}>
                        Aquí puedes agregar el contenido informativo que deseas mostrar cuando el usuario hace clic en el botón.
                        Puedes incluir detalles sobre tus servicios, beneficios de la energía solar, o cualquier otra información relevante.
                    </Typography>
                    <Button
                        onClick={handleCloseModal}
                        sx={{
                            color: '#EBC848',
                            fontFamily: 'Montserrat, sans-serif',
                            fontWeight: 600,
                            border: '1px solid #EBC848',
                            fontSize: isMobile ? '0.8rem' : '0.9rem',
                            '&:hover': {
                                backgroundColor: 'rgba(235, 200, 72, 0.1)'
                            }
                        }}
                    >
                        Cerrar
                    </Button>
                </Box>
            </Modal>
        </Box>
    );
};

export default Home;